const styles = {
  summaryCard: {
    gridColumn: '1 / -1',
    gridRow: '1',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    borderRadius: 0,
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 0,
    height: '100%',
    minWidth: 0,
  },
  summaryCardContent: {
    height: '100%',
    padding: 0,
  },
  contentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: 4,       
    boxSizing: 'border-box',
    gap: 2,           
    flexWrap: { xs: 'wrap', md: 'nowrap' },
  },
  item: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    minWidth: 0,
    padding: { xs: 2, md: 0 },
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    pt: 3,
    gap: 0.5,
  },
  label: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.4,
    color: '#000',
  },
  value: {
    fontWeight: 600,
    fontSize: 14,
    color: '#777',
    lineHeight: 1.4,
    wordBreak: 'break-word',
  },
};

export default styles;
